import type { BubblePointPressurePSIACalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const bubblePointPressurePSIACalculator: BubblePointPressurePSIACalculator =
  params => {
    const {
      gasSpecificGravity,
      oilAPI,
      temperatureF,
      solutionGasRsoAtReservoir
    } = params;

    // D128: =((J15/D8)^0.816)*(((D4)^0.172)/(D7^0.989))
    const A =
      (solutionGasRsoAtReservoir / gasSpecificGravity) ** 0.816 *
      (temperatureF ** 0.172 / oilAPI ** 0.989);
    // D130: =1.7669+1.7447*LOG10(D128)-0.30218*(LOG10(D128))^2
    const logPb =
      1.7669 + 1.7447 * Math.log10(A) - 0.30218 * Math.log10(A) ** 2;
    // D113: IF(D11>0,D11,10^D111) --  NOTE:  ONLY THE FINAL CLAUSE APPLIES: 10^D111
    const bubblePointPressurePSIA = 10 ** logPb;

    return {
      bubblePointPressurePSIA,
      A,
      logPb
    };
  };
